export var DEFAULT_LOGIN_APPLICATION = 'premier-inn';
export var DEFAULT_LOGIN_EXT_APPLICATION = 'web';
export var DEFAULT_LOGIN_EXT_PATH = 'home';
export function resolveAuthEntryPoint(url) {
  var pathname;
  try {
    pathname = new URL(url).pathname.toLowerCase();
  } catch (_unused) {
    pathname = url.toLowerCase();
  }
  if (pathname.includes('/guest-details')) return 'guest_details_page';
  if (pathname.includes('/confirmation')) return 'confirmation';
  if (pathname.includes('/account/settings')) return 'settings';
  if (pathname.includes('/account/dashboard')) return 'booking_dashboard';
  if (pathname.includes('/home')) return 'top_nav_home';
  if (pathname.includes('/search')) return 'top_nav_srp';
  if (pathname.includes('/hotels/')) return 'top_nav_hdp';
  return 'top_nav_other';
}
export function getLanguageFromPath(pathname) {
  if (!pathname) return null;
  var match = pathname.match(/^\/(gb|de)\/(en|de)(?:\/|$)/);
  return match ? match[2] : null;
}
export function getDefaultLoginParams(_ref) {
  var currentUrl = _ref.currentUrl,
    origin = _ref.origin,
    language = _ref.language,
    connection = _ref.connection;
  var params = {
    returnTo: currentUrl,
    application: DEFAULT_LOGIN_APPLICATION,
    'ext-application': DEFAULT_LOGIN_EXT_APPLICATION,
    'ext-path': DEFAULT_LOGIN_EXT_PATH,
    'ext-authEntryPoint': resolveAuthEntryPoint(currentUrl)
  };
  if (language) {
    params.ui_locales = language;
  }
  if (connection) {
    params.connection = connection;
    params['ext-connection'] = connection;
    params['ext-origin'] = origin;
  }
  return params;
}